export default __webpack_public_path__ + "static/media/scek2.2dde9ef4.jpg";